var modules_56feba8c = {"inputWrapper":"TextInput_module_inputWrapper__07baecc8","searchInput":"TextInput_module_searchInput__07baecc8"};
import "../../../assets/esm/components/GlobalSearch/TextInput~BYapackC.css";

export { modules_56feba8c as default };
//# sourceMappingURL=TextInput.module.less.js.map
